import { message } from "antd";
import axiosInstance from "../../../../helpers/axios";
import { responseDataFormate } from "../../../../helpers/bycrypt";

export interface ColorFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

interface GetColorListParams {
  filters: ColorFilterParams;
  signal?: AbortSignal;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getColorsListAPI =
  ({ filters, onSuccess, onError, signal }: GetColorListParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/colors", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
      console.error("Get Colors List Error:", error);
      message.error(error?.response?.data?.message);
      onError?.();
    }
  };

interface UpdateColorParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateColorAPI =
  ({ payload, onSuccess, onError }: UpdateColorParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/colors", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Color updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update Color");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Color error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to update Color";
      message.error(errorMessage);
    }
  };

interface CreateColorParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const createColorAPI =
  ({ payload, onSuccess, onError }: CreateColorParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post("/colors", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Create Color error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

interface DeleteColorParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteColorAPI =
  ({ id, onSuccess, onError }: DeleteColorParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete("/colors", {
        data: { id: id },
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Color deleted successfully");
        onSuccess?.();
      } else {
        message.error(result?.message || "Failed to delete Color");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Color error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to delete Color";
      message.error(errorMessage);
    }
  };

interface ReorderColorParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const reorderColorAPI =
  ({ payload, onSuccess, onError }: ReorderColorParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/colors/reorder", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Reorder error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };
